/// <amd-module name="Search/Package/Components/ViewFilterItem" />

import * as React from "react";
import * as Shared from "Search/WebApi/Contracts/Search.Shared";
import { HighlightComponent } from "Search/Shared/Components/HighlightComponent";

export interface IViewFilterItemProps {
    item: Shared.Filter;

    hitText: string;
}

export const ViewFilterItem = (props: IViewFilterItemProps) => {
    return <HighlightComponent
        text={props.item.name}
        pattern={props.hitText}
        className={"search-view-filter-item flex-row"} />
}
